import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { Stack, Typography } from "@mui/material";
import { EmptyTimesMessageProps } from "./types";

export function EmptyTimesMessage({ message, submessage }: EmptyTimesMessageProps) {
  return (
    <Stack alignItems="center" gap={1} py={2} px={2}>
      <AccessTimeOutlinedIcon sx={{ fontSize: 28, color: "warning.main" }} />
      <Typography variant="body2" fontWeight={600} color="text.primary">
        {message}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        textAlign="center"
        maxWidth={280}
      >
        {submessage}
      </Typography>
    </Stack>
  );
}
